// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 990px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: -75px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 991px) {
  .container-datepicker {
    float: left;
    width: 100%;
    margin: 15px 7.5px 15px 7.5px;
  }
  .container-datepicker app-datepicker {
    margin: 20px 0 20px 0;
    float: right;
  }
}
@media only screen and (max-width: 515px) {
  .container-datepicker {
    margin: 0;
    padding: 0 7.5px;
  }
  app-datepicker {
    width: 100%;
  }
}
.caixa-pesquisa {
  cursor: text;
}
.caixa-pesquisa div input {
  position: absolute;
  left: 55px;
  width: 300px;
  max-width: calc(100% - 75px);
  outline: none;
  border: 0px;
  height: 40px;
}
.caixa-pesquisa input.search {
  position: relative;
  border-radius: 6px;
  height: 40px;
  width: 100%;
  margin: 0 0 20px 0;
  border: none;
  padding: 5px 50px;
  outline: none;
  transition: border-color 0.5s ease;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
}
.caixa-pesquisa input.search:active, .caixa-pesquisa input.search:hover, .caixa-pesquisa input.search:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}
.caixa-pesquisa::after, .caixa-pesquisa::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  top: 8px;
}
.caixa-pesquisa::before {
  left: 20px;
  background-image: url("/assets/img/icons/pesquisa.svg");
}
.caixa-pesquisa::after {
  right: 20px;
  cursor: pointer;
  background-image: url("/assets/img/icons/filtro.svg");
}
.caixa-pesquisa .filter-icon {
  position: absolute;
  top: 0;
  right: 12px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  z-index: 5;
}
.caixa-pesquisa .box-filter {
  z-index: 5;
  position: absolute;
  width: 250px;
  top: 0;
  right: -245px;
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);
  overflow: hidden;
}
.caixa-pesquisa .box-filter.box-hidden {
  transition: 0.4s;
  opacity: 0;
  z-index: -1;
}
.caixa-pesquisa .box-filter.box-show {
  transition: 0.4s;
  opacity: 1;
}
.caixa-pesquisa .box-filter .container-box-inner {
  float: left;
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner label {
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner label:first-child {
  width: 100%;
}
.caixa-pesquisa .box-filter .container-box-inner > div {
  margin-bottom: 2px;
  float: left;
}
.caixa-pesquisa .box-filter .container-box-inner > div label {
  margin-right: 5px;
  color: #999999;
  background: rgba(204, 204, 204, 0.2);
  padding: 5px 10px;
  border-radius: 3px;
  transition: 0.5s;
  cursor: pointer;
}
.caixa-pesquisa .box-filter .container-box-inner > div label:hover {
  background: rgba(204, 204, 204, 0.4);
  transition: 0.5s;
}
.caixa-pesquisa .box-filter .container-box-inner:last-child {
  margin-top: 15px;
}

.modal-header {
  padding: 15px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
}
.modal-header:after {
  content: normal;
}
.modal-header h2 {
  font-weight: 100;
  text-align: center;
  margin-top: 15px;
}
.modal-header.venda-recebida {
  background-color: rgba(34, 183, 255, 0.25);
}
.modal-header.venda-recebida h2 {
  color: #22b7ff;
}
.modal-header.venda-cancelada {
  background-color: rgba(229, 115, 115, 0.25);
}
.modal-header.venda-cancelada h2 {
  color: #e57373;
}
.modal-header.venda-agendada {
  background-color: rgba(67, 121, 255, 0.25);
}
.modal-header.venda-agendada h2 {
  color: #4379ff;
}
.modal-header.venda-aberta {
  background-color: rgba(204, 204, 204, 0.25);
}
.modal-header.venda-ativa {
  background-color: rgba(164, 44, 255, 0.1);
}
.modal-header.venda-ativa h2 {
  color: #a42cff;
}
.modal-header.header-estornar h2 {
  color: #edaf80;
}

.modal-body {
  margin-top: 90px;
}
.modal-body .recebido {
  text-decoration: line-through;
  color: #e6e6e6;
}
.modal-body .alterar-cartao {
  color: #22b7ff;
  transition: 0.4s;
  margin-left: 15px;
}
.modal-body .alterar-cartao:hover {
  cursor: pointer;
  transition: 0.4s;
  text-decoration: underline;
}
.modal-body p {
  font-size: 14px;
  font-weight: 600;
}
.modal-body p.info-cartao {
  margin: 5px 0 0 -4px;
}
.modal-body p .bandeira-cartao {
  margin-top: -4px;
  margin-right: 5px;
}
.modal-body p small {
  margin-left: 5px;
  color: #999999;
  font-weight: 200;
}
.modal-body h4 {
  margin: 0;
  font-weight: 200;
  font-size: 26px;
}
.modal-body .empty {
  color: #999999;
  font-weight: 300;
  font-size: 16px;
}
.modal-body .btn-action {
  float: left;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.modal-body .btn {
  margin-top: 30px;
}
.modal-body .btn:first-child {
  margin-right: 2px;
}
.modal-body .btn:last-child {
  margin-left: 2px;
}
.modal-body .btn.loading {
  margin-right: 30px;
}
.modal-body .btn.loading::before {
  background-color: #fff;
}
.modal-body .btn-cancelar {
  background-color: #e57373;
  color: #fff;
}
.modal-body .btn-default {
  border: none;
  background-color: rgba(204, 204, 204, 0.25);
}
.modal-body .btn-default:hover {
  background-color: rgba(204, 204, 204, 0.5);
}
.modal-body svg {
  width: 90px;
  height: 90px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 50px;
}
.modal-body .cobrancas ol {
  columns: 2;
  -webkit-columns: 2;
  padding-left: 15px;
}
.modal-body .cobrancas .recebida {
  text-decoration: line-through;
  color: #e2e2e2;
}

.container-loading {
  width: 35px;
  height: 35px;
  margin: 0 auto;
}
.container-loading .loading {
  margin: 100px 0 0 0;
}

.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/vendas/vendas.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AACA;EACI;IACI,WAAA;IACA,WAAA;IACA,8BAAA;EAAN;EACM;IACI,qBAAA;IACA,YAAA;EACV;AACF;AAGA;EACI;IACI,WAAA;IACA,WAAA;IACA,6BAAA;EADN;EAEM;IACI,qBAAA;IACA,YAAA;EAAV;AACF;AAIA;EACI;IACI,SAAA;IACA,gBAAA;EAFN;EAIE;IACI,WAAA;EAFN;AACF;AAKA;EACI,YAAA;AAHJ;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAHZ;AAMI;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,kCAAA;EACA,iDAAA;AAJR;AAKQ;EAGI,gDAAA;AALZ;AAQI;EAEI,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AAPR;AASI;EACI,UAAA;EACA,uDAAA;AAPR;AASI;EACI,WAAA;EACA,eAAA;EACA,qDAAA;AAPR;AASI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAPR;AASI;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,sBCzEA;ED0EA,aAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAPR;AAQQ;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AANZ;AAQQ;EACI,gBAAA;EACA,UAAA;AANZ;AAQQ;EACI,WAAA;EACA,WAAA;AANZ;AAOY;EACI,WAAA;AALhB;AAMgB;EACI,WAAA;AAJpB;AAOY;EACI,kBAAA;EACA,WAAA;AALhB;AAMgB;EACI,iBAAA;EACA,cC5GR;ED6GQ,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAJpB;AAKoB;EACI,oCAAA;EACA,gBAAA;AAHxB;AAOY;EACI,gBAAA;AALhB;;AAWA;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AARF;AASE;EACI,eAAA;AAPN;AASE;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;AAPN;AASE;EACI,0CAAA;AAPN;AAQM;EACI,cC3JC;ADqJX;AASE;EACI,2CAAA;AAPN;AAQM;EACE,cCvIC;ADiIT;AASE;EACE,0CAAA;AAPJ;AAQI;EACE,cCtKK;ADgKX;AASE;EACI,2CAAA;AAPN;AASE;EACE,yCAAA;AAPJ;AAQI;EACE,cC5KK;ADsKX;AAUI;EACE,cC5JI;ADoJV;;AAaA;EACE,gBAAA;AAVF;AAWE;EACE,6BAAA;EACA,cCjLQ;ADwKZ;AAWE;EACE,cCjMO;EDkMP,gBAAA;EACA,iBAAA;AATJ;AAUI;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AARN;AAWE;EACI,eAAA;EACA,gBAAA;AATN;AAUM;EACI,oBAAA;AARV;AAUM;EACI,gBAAA;EACA,iBAAA;AARV;AAUM;EACI,gBAAA;EACA,cC5ME;ED6MF,gBAAA;AARV;AAYE;EACI,SAAA;EACA,gBAAA;EACA,eAAA;AAVN;AAaE;EACI,cCxNM;EDyNN,gBAAA;EACA,eAAA;AAXN;AAcE;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AAZN;AAeE;EACI,gBAAA;AAbN;AAcM;EACI,iBAAA;AAZV;AAcM;EACI,gBAAA;AAZV;AAcM;EACI,kBAAA;AAZV;AAaU;EACI,sBAAA;AAXd;AAgBE;EACI,yBAAA;EACA,WAAA;AAdN;AAiBE;EACI,YAAA;EACA,2CAAA;AAfN;AAgBM;EACI,0CAAA;AAdV;AAiBE;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAfN;AAkBI;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;AAhBN;AAkBI;EACE,6BAAA;EACA,cC9QM;AD8PZ;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AAlBJ;AAmBI;EACI,mBAAA;AAjBR;;AAqBA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cClSU;EDmSV,kBAAA;EACA,qBAAA;AAlBF;AAmBE;EACE,iBAAA;AAjBJ","sourcesContent":["@import '../../../../../sass/variables';\n@media only screen and (min-width: 990px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: -75px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .container-datepicker {\n        float: left;\n        width: 100%;\n        margin: 15px 7.5px 15px 7.5px;\n        app-datepicker {\n            margin: 20px 0 20px 0;\n            float: right;\n        }\n    }\n}\n\n@media only screen and (max-width: 515px) {\n    .container-datepicker {\n        margin: 0;\n        padding: 0 7.5px;\n    }\n    app-datepicker {\n        width: 100%;\n    }\n}\n\n.caixa-pesquisa {\n    cursor: text;\n    div {\n        input {\n            position: absolute;\n            left: 55px;\n            width: 300px;\n            max-width: calc(100% - 75px);\n            outline: none;\n            border: 0px;\n            height: 40px;\n        }\n    }\n    input.search {\n        position: relative;\n        border-radius: 6px;\n        height: 40px;\n        width: 100%;\n        margin: 0 0 20px 0;\n        border: none;\n        padding: 5px 50px;\n        outline: none;\n        transition: border-color 0.5s ease;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        &:active,\n        &:hover,\n        &:focus {\n            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);\n        }\n    }\n    &::after,\n    &::before {\n        content: ' ';\n        position: absolute;\n        display: inline-block;\n        width: 24px;\n        height: 24px;\n        top: 8px;\n    }\n    &::before {\n        left: 20px;\n        background-image: url('/assets/img/icons/pesquisa.svg');\n    }\n    &::after {\n        right: 20px;\n        cursor: pointer;\n        background-image: url('/assets/img/icons/filtro.svg');\n    }\n    .filter-icon {\n        position: absolute;\n        top: 0;\n        right: 12px;\n        height: 40px;\n        width: 40px;\n        cursor: pointer;\n        z-index: 5;\n    }\n    .box-filter {\n        z-index: 5;\n        position: absolute;\n        width: 250px;\n        top: 0;\n        right: -245px;\n        background-color: $white;\n        padding: 20px;\n        border-radius: 6px;\n        box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.21);\n        overflow: hidden;\n        &.box-hidden {\n            transition: 0.4s;\n            opacity: 0;\n            z-index: -1;\n        }\n        &.box-show {\n            transition: 0.4s;\n            opacity: 1;\n        }\n        .container-box-inner {\n            float: left;\n            width: 100%;\n            label {\n                float: left;\n                &:first-child {\n                    width: 100%;\n                }\n            }\n            >div {\n                margin-bottom: 2px;\n                float: left;\n                label {\n                    margin-right: 5px;\n                    color: $cinza-500;\n                    background: rgba($cinza-400, 0.2);\n                    padding: 5px 10px;\n                    border-radius: 3px;\n                    transition: 0.5s;\n                    cursor: pointer;\n                    &:hover {\n                        background: rgba($cinza-400, 0.4);\n                        transition: 0.5s;\n                    }\n                }\n            }\n            &:last-child {\n                margin-top: 15px;\n            }\n        }\n    }\n}\n\n.modal-header {\n  padding: 15px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 90px;\n  &:after {\n      content: normal;\n  }\n  h2 {\n      font-weight: 100;\n      text-align: center;\n      margin-top: 15px;\n  }\n  &.venda-recebida {\n      background-color: rgba($azul-400, .25);\n      h2 {\n          color: $azul-400;\n      }\n  }\n  &.venda-cancelada {\n      background-color: rgba($danger, 0.25);\n      h2 {\n        color: $danger;\n      }\n  }\n  &.venda-agendada {\n    background-color: rgba($azul-500, 0.25);\n    h2 {\n      color: $azul-500;\n    }\n  }\n  &.venda-aberta {\n      background-color: rgba($cinza-400, 0.25);\n  }\n  &.venda-ativa {\n    background-color: rgba($roxo-400, 0.1);\n    h2 {\n      color: $roxo-400;\n    }\n  }\n  &.header-estornar {\n    h2 {\n      color: $warning;\n    }\n  }\n}\n\n.modal-body {\n  margin-top: 90px;\n  .recebido {\n    text-decoration: line-through;\n    color: $cinza-200;\n  }\n  .alterar-cartao {\n    color: $azul-400;\n    transition: 0.4s;\n    margin-left: 15px;\n    &:hover {\n      cursor: pointer;\n      transition: 0.4s;\n      text-decoration: underline;\n    }\n  }\n  p {\n      font-size: 14px;\n      font-weight: 600;\n      &.info-cartao {\n          margin: 5px 0 0 -4px;\n      }\n      .bandeira-cartao {\n          margin-top: -4px;\n          margin-right: 5px;\n      }\n      small {\n          margin-left: 5px;\n          color: $cinza-500;\n          font-weight: 200;\n      }\n  }\n\n  h4 {\n      margin: 0;\n      font-weight: 200;\n      font-size: 26px;\n  }\n\n  .empty {\n      color: $cinza-500;\n      font-weight: 300;\n      font-size: 16px;\n  }\n\n  .btn-action {\n      float: left;\n      position: relative;\n      left: 50%;\n      transform: translateX(-50%);\n  }\n\n  .btn {\n      margin-top: 30px;\n      &:first-child {\n          margin-right: 2px;\n      }\n      &:last-child {\n          margin-left: 2px;\n      }\n      &.loading {\n          margin-right: 30px;\n          &::before {\n              background-color: #fff;\n          }\n      }\n  }\n\n  .btn-cancelar {\n      background-color: rgba($danger, 1);\n      color: #fff;\n  }\n\n  .btn-default {\n      border: none;\n      background-color: rgba($cinza-400, 0.25);\n      &:hover {\n          background-color: rgba($cinza-400, 0.5);\n      }\n  }\n  svg {\n      width: 90px;\n      height: 90px;\n      position: relative;\n      left: 50%;\n      transform: translateX(-50%);\n      margin-bottom: 50px;\n  }\n  .cobrancas {\n    ol {\n      columns: 2;\n      -webkit-columns: 2;\n      padding-left: 15px;\n    }\n    .recebida {\n      text-decoration: line-through;\n      color: $cinza-300;\n    }\n  }\n}\n\n.container-loading {\n    width: 35px;\n    height: 35px;\n    margin: 0 auto;\n    .loading {\n        margin: 100px 0 0 0;\n    }\n}\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
